var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPress({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 36,
    viewBox: "0 0 43 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8199 2.75879H0V35.9129H42.8199V2.75879Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8199 35.9123H0V1.69824H33.5019L42.8199 10.0192V35.9123Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2559 7.62599V11.0416H11.4908V6.19043H12.092L14.8649 9.68922V6.19673H15.6375V11.0416H15.0073L12.2559 7.62599Z",
    fill: "#E51C27"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.06 10.366V11.0416H16.7327V6.19043H19.9983V6.86725H17.5028V8.25366H19.6693V8.88384H17.5028V10.366H20.06Z",
    fill: "#E51C27"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5745 6.2106H23.3005L23.8953 7.8579L24.4965 6.2106H25.2137L24.3869 8.37087L25.1116 10.1543L26.624 6.19043H27.4597L25.4569 11.0416H24.8016L23.8991 8.86872L22.9904 11.0416H22.335L20.3323 6.19043H21.1654L22.6778 10.1543L23.4025 8.37087L22.5745 6.2106Z",
    fill: "#E51C27"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7895 7.33216C30.7295 7.27135 30.6627 7.21764 30.5904 7.17209C30.4942 7.10964 30.3925 7.05606 30.2866 7.01203C30.1648 6.95831 30.0382 6.91611 29.9085 6.88599C29.7687 6.85417 29.6258 6.8381 29.4825 6.8381C29.1582 6.8381 28.92 6.89733 28.7679 7.01581C28.693 7.07334 28.6331 7.14803 28.5932 7.23358C28.5532 7.31913 28.5345 7.41303 28.5385 7.50735C28.5342 7.60926 28.5591 7.71027 28.6103 7.7985C28.6674 7.8812 28.7435 7.94905 28.8321 7.99638C28.9519 8.06102 29.0788 8.11136 29.2103 8.14636C29.3607 8.19089 29.5359 8.23753 29.7358 8.28626C29.9618 8.33963 30.1844 8.40612 30.4026 8.4854C30.583 8.54817 30.753 8.63782 30.9067 8.75134C31.0416 8.85293 31.1505 8.98512 31.2243 9.13701C31.3044 9.31153 31.3432 9.50216 31.3378 9.6941C31.3437 9.91449 31.2957 10.133 31.1979 10.3306C31.1088 10.5036 30.9791 10.6524 30.8198 10.7642C30.6489 10.8805 30.4579 10.9639 30.2564 11.0099C30.0301 11.0638 29.7982 11.09 29.5657 11.0881C29.2029 11.089 28.8422 11.0329 28.4969 10.9217C28.1601 10.8137 27.8446 10.6482 27.5642 10.4327L27.9121 9.77602C27.9895 9.85037 28.0739 9.91706 28.1641 9.97516C28.2879 10.0535 28.4182 10.1209 28.5536 10.1768C28.7105 10.2405 28.8718 10.2928 29.0363 10.3331C29.2127 10.3774 29.3939 10.3995 29.5758 10.3986C29.8183 10.4126 30.0598 10.358 30.2728 10.2411C30.3516 10.1927 30.416 10.124 30.4592 10.0422C30.5025 9.96036 30.5229 9.86845 30.5185 9.77602C30.5222 9.66623 30.4899 9.55824 30.4265 9.46849C30.3556 9.37848 30.2657 9.3053 30.1631 9.25423C30.0303 9.1848 29.891 9.12865 29.7472 9.0866C29.5821 9.03618 29.3955 8.98325 29.1863 8.92905C28.9725 8.87421 28.7621 8.80688 28.5561 8.72739C28.3945 8.66786 28.2434 8.58275 28.1087 8.47532C27.9941 8.3793 27.902 8.25925 27.839 8.12368C27.7735 7.96916 27.7422 7.80237 27.747 7.63465C27.7434 7.41693 27.79 7.2013 27.8831 7.00447C27.973 6.82363 28.1022 6.66517 28.2612 6.54065C28.4265 6.41051 28.6158 6.31415 28.8183 6.25707C29.0447 6.19126 29.2795 6.15899 29.5153 6.16128C29.8251 6.15799 30.133 6.21095 30.424 6.31756C30.6843 6.41389 30.9303 6.54534 31.155 6.70828L30.7895 7.33216Z",
    fill: "#E51C27"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9088 4.73998H1.91455V3.81738H35.8753L36.9088 4.73998Z",
    fill: "#C7C7C7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.603 3.57562H1.91455V3.3916H35.3988L35.603 3.57562Z",
    fill: "#C7C7C7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4986 5.26576H1.91455V5.08301H37.2932L37.4986 5.26576Z",
    fill: "#C7C7C7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9067 12.1807H1.91455V13.102H40.9067V12.1807Z",
    fill: "#C7C7C7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9067 11.7568H1.91455V11.9396H40.9067V11.7568Z",
    fill: "#C7C7C7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9067 13.4482H1.91455V13.6297H40.9067V13.4482Z",
    fill: "#C7C7C7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77719 6.19043H1.91321V11.0429H8.77719V6.19043Z",
    fill: "#C7C7C7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9053 8.30981V11.0423H34.0426V6.19238H38.5346L40.9053 8.30981Z",
    fill: "#C7C7C7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3397 29.21L29.48 29.21V16.8079H13.3397V29.21Z",
    fill: "#E51C27"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.074 19.7149C15.0147 20.0174 15.0541 20.3309 15.1864 20.6092C15.3187 20.8876 15.537 21.116 15.809 21.261C16.081 21.4059 16.3923 21.4596 16.6972 21.4142C17.002 21.3688 17.2842 21.2266 17.5021 21.0087C17.72 20.7907 17.8622 20.5086 17.9076 20.2037C17.953 19.8989 17.8993 19.5876 17.7544 19.3156C17.6094 19.0436 17.381 18.8253 17.1026 18.693C16.8243 18.5607 16.5108 18.5213 16.2084 18.5806C15.9281 18.6359 15.6707 18.7733 15.4687 18.9753C15.2667 19.1773 15.1293 19.4347 15.074 19.7149Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.8154 26.5918H29.4802L23.6472 20.0518L17.8154 26.5918Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3398 26.5989H22.9703L18.1545 22.3389L13.3398 26.5989Z",
    fill: "#E51C27"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M13.3398 26.5989H22.9703L18.1545 22.3389L13.3398 26.5989Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4802 26.5928H13.3398V29.2106H29.4802V26.5928Z",
    fill: "#E51C27"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M29.4802 26.5928H13.3398V29.2106H29.4802V26.5928Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2612 14.7549H13.3398V15.1872H26.2612V14.7549Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5834 15.6943H13.3398V16.1266H22.5834V15.6943Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4909 14.7627H1.91455V15.195H11.4909V14.7627Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4833 16.8057H1.90698V17.238H11.4833V16.8057Z",
    fill: "#DBDBDB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4833 17.6123H1.90698V18.0446H11.4833V17.6123Z",
    fill: "#DBDBDB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4833 18.4189H1.90698V18.8513H11.4833V18.4189Z",
    fill: "#DBDBDB"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4833 19.2256H1.90698V19.6579H11.4833V19.2256Z",
    fill: "#DBDBDB"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4833 20.0322H1.90698V20.4645H11.4833V20.0322Z",
    fill: "#DBDBDB"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4833 20.8389H1.90698V21.2712H11.4833V20.8389Z",
    fill: "#DBDBDB"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4833 21.6455H1.90698V22.0778H11.4833V21.6455Z",
    fill: "#DBDBDB"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4833 22.4521H1.90698V22.8845H11.4833V22.4521Z",
    fill: "#DBDBDB"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51564 23.2588H1.90698V23.6911H7.51564V23.2588Z",
    fill: "#DBDBDB"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4833 24.8721H1.90698V25.3044H11.4833V24.8721Z",
    fill: "#DBDBDB"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4833 25.6787H1.90698V26.111H11.4833V25.6787Z",
    fill: "#DBDBDB"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4833 26.4834H1.90698V26.9157H11.4833V26.4834Z",
    fill: "#DBDBDB"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4833 27.29H1.90698V27.7223H11.4833V27.29Z",
    fill: "#DBDBDB"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51564 28.0967H1.90698V28.529H7.51564V28.0967Z",
    fill: "#DBDBDB"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76593 15.7002H1.91455V16.1325H8.76593V15.7002Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9054 14.7627H31.3291V15.195H40.9054V14.7627Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8977 16.8057H31.3214V17.238H40.8977V16.8057Z",
    fill: "#DBDBDB"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8977 17.6123H31.3214V18.0446H40.8977V17.6123Z",
    fill: "#DBDBDB"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8977 18.4189H31.3214V18.8513H40.8977V18.4189Z",
    fill: "#DBDBDB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9679 19.2256H31.3214V19.6579H36.9679V19.2256Z",
    fill: "#DBDBDB"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8977 20.8389H31.3214V21.2712H40.8977V20.8389Z",
    fill: "#DBDBDB"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8977 21.6455H31.3214V22.0778H40.8977V21.6455Z",
    fill: "#DBDBDB"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8977 22.4521H31.3214V22.8845H40.8977V22.4521Z",
    fill: "#DBDBDB"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8977 23.2588H31.3214V23.6911H40.8977V23.2588Z",
    fill: "#DBDBDB"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9679 24.0654H31.3214V24.4977H36.9679V24.0654Z",
    fill: "#DBDBDB"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8977 25.6787H31.3214V26.111H40.8977V25.6787Z",
    fill: "#DBDBDB"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8977 26.4834H31.3214V26.9157H40.8977V26.4834Z",
    fill: "#DBDBDB"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8977 27.29H31.3214V27.7223H40.8977V27.29Z",
    fill: "#DBDBDB"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8977 28.0967H31.3214V28.529H40.8977V28.0967Z",
    fill: "#DBDBDB"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9679 28.9033H31.3214V29.3356H36.9679V28.9033Z",
    fill: "#DBDBDB"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1805 15.7002H31.3291V16.1325H38.1805V15.7002Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4909 30.5713H1.91455V31.0036H11.4909V30.5713Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4833 32.6162H1.90698V33.0485H11.4833V32.6162Z",
    fill: "#DBDBDB"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4833 33.4229H1.90698V33.8552H11.4833V33.4229Z",
    fill: "#DBDBDB"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4833 34.2275H1.90698V34.6598H11.4833V34.2275Z",
    fill: "#DBDBDB"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4833 35.0361H1.90698V35.4684H11.4833V35.0361Z",
    fill: "#DBDBDB"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76593 31.5107H1.91455V31.943H8.76593V31.5107Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4802 30.5713H13.3751V31.0036H29.4802V30.5713Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4673 32.6162H13.3623V33.0485H29.4673V32.6162Z",
    fill: "#DBDBDB"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4673 33.4229H13.3623V33.8552H29.4673V33.4229Z",
    fill: "#DBDBDB"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4673 34.2275H13.3623V34.6598H29.4673V34.2275Z",
    fill: "#DBDBDB"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4673 35.0361H13.3623V35.4684H29.4673V35.0361Z",
    fill: "#DBDBDB"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8962 31.5107H13.3751V31.943H24.8962V31.5107Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9054 30.5713H31.3291V31.0036H40.9054V30.5713Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8977 32.6162H31.3214V33.0485H40.8977V32.6162Z",
    fill: "#DBDBDB"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8977 33.4229H31.3214V33.8552H40.8977V33.4229Z",
    fill: "#DBDBDB"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8977 34.2275H31.3214V34.6598H40.8977V34.2275Z",
    fill: "#DBDBDB"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9679 35.0361H31.3214V35.4684H36.9679V35.0361Z",
    fill: "#DBDBDB"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1805 31.5107H31.3291V31.943H38.1805V31.5107Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M33.502 1.69824L33.7402 10.0646L42.8199 10.0192L33.502 1.69824Z",
    fill: "#DBDBDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPress);
export default __webpack_public_path__ + "static/media/press.783968506b68fc9ab4327b9f4fdc582f.svg";
export { ForwardRef as ReactComponent };